module.exports = __webpack_public_path__ + "img/andy_pasos1.427e6b94.svg";